module.exports = __webpack_public_path__ + "static/media/share-icon.59864de0.jpg";